(function () {
  function parseCampaignDate(value, endOfDay) {
    if (!value) return null;
    var match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    var date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    if (endOfDay) {
      date.setHours(23, 59, 59, 999);
    }
    return date;
  }

  function updateCampaign(section) {
    if (!section) return;

    var start = parseCampaignDate(section.dataset.startDate, false);
    var end = parseCampaignDate(section.dataset.endDate, true);
    var now = new Date();
    var outsideWindow = (start && now < start) || (end && now > end);

    section.hidden = Boolean(outsideWindow);
  }

  function initCampaigns(root) {
    var scope = root || document;
    var campaigns = scope.querySelectorAll('[data-seasonal-campaign]');
    campaigns.forEach(updateCampaign);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCampaigns(document);
    });
  } else {
    initCampaigns(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCampaigns(event.target);
  });
})();
